import appLogger from '@/utils/logger';
import { DOMAIN_REGEX } from '@/constants/regex';
import { IChatQueryRecommendation, IRecommendationInfo } from '@/types';
import { get } from 'lodash';
import { handleApiError } from '@/utils/errorHandling';

/**
 * @deprecated Use `handleApiError` from `@/utils/errorHandling` instead.
 * Kept for backward compatibility — delegates to the unified implementation.
 */
export const handleShowError = (error: unknown) => {
  handleApiError(error);
};

const generateSpecificationIconPath = (iconName?: string) => {
  return `/icons/${iconName}.svg`;
};

export const copyToClipboard = async (content: string) => {
  try {
    await navigator.clipboard.writeText(content);
    return true;
  } catch (err) {
    appLogger.error('Failed to copy: ', { data: err });
    return false;
  }
};

export const sortArray = (
  array: any[],
  options?: { sortBy?: string; isAscending?: boolean; isSortByDate?: boolean },
) => {
  const { sortBy = '', isAscending = true, isSortByDate = false } = options || {};

  return array.sort((a: any, b: any) => {
    if (!sortBy) {
      return isAscending ? a - b : b - a;
    }

    if (isSortByDate) {
      return isAscending
        ? new Date(get(a, sortBy)).getTime() - new Date(get(b, sortBy)).getTime()
        : new Date(get(b, sortBy)).getTime() - new Date(get(a, sortBy)).getTime();
    }

    return isAscending ? get(a, sortBy) - get(b, sortBy) : get(b, sortBy) - get(a, sortBy);
  });
};

export const isUrl = (string: string) => {
  if (typeof string !== 'string') return false;

  return !!DOMAIN_REGEX.test(string);
};

const generateProductsFromRecommendations = (recommendations?: IChatQueryRecommendation) => {
  if (!recommendations) return [];
  let result: IRecommendationInfo[] = [];
  Object.entries(recommendations).forEach(([key, value]) => {
    const products = value?.map((it) => ({
      ...it,
      // recommendationType: key,
      recommendationType: it.type,
    }));

    result = [...result, ...products];
  });

  return result;
};

const generateRandomColor = () => {
  const R = Math.floor(Math.random() * 127 + 127);
  const G = Math.floor(Math.random() * 127 + 127);
  const B = Math.floor(Math.random() * 127 + 127);

  const rgb = (R << 16) + (G << 8) + B;
  return `#${rgb.toString(16)}`;
};

const generateUniqueColor = (existingColors: string[]) => {
  let newColor = generateRandomColor();

  // Check if the generated color is already in the existing list
  while (existingColors.includes(newColor)) {
    newColor = generateRandomColor();
  }

  return newColor;
};

const numOfWords = (str: string) => {
  return (
    str
      ?.trim()
      ?.split(/\s+/)
      ?.filter((it) => !!it).length || 0
  );
};
